import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { requestAuthentication } from '../../actions/authentication';
import { ResultsEmptyForAuthorization } from '../../components/ResultsEmpty/ResultsEmptyForAutorisation';
import { trackSignInButtonClick } from '../../components/ResultsEmpty/tracking';
import { selectPage } from '../../selectors/page';

export function ResultsEmptyForAuthorizationContainer() {
  const dispatch = useDispatch();
  const page = useSelector(selectPage);
  const { deviceType } = page;

  const onClick = React.useCallback(() => {
    dispatch(requestAuthentication());
    trackSignInButtonClick();
  }, [dispatch]);

  return <ResultsEmptyForAuthorization deviceType={deviceType} onClick={onClick} />;
}
